import {
  CampaignAdminModelMarketingStatus,
  CampaignAdminModelStage,
} from '@urbanx/agx.campaigns.client';
import { LaunchFilterOptions } from 'types/campaigns';

interface CampaignsFilterState {
  statusFilter?: CampaignAdminModelStage[];
  agentsFilter?: string[];
  marketingFilter?: CampaignAdminModelMarketingStatus[];
  contractFilter?: string[];
  launchFilter?: LaunchFilterOptions;
}

const storedCampaignsFilterStateKey = 'campaignsFilterState';

export const getStoredCampaignsFilterState = (agencyId: string): CampaignsFilterState | null => {
  const storedState = localStorage.getItem(`${storedCampaignsFilterStateKey}-${agencyId}`);
  if (storedState) {
    try {
      return JSON.parse(storedState) as CampaignsFilterState;
    } catch (error) {
      console.error('Error parsing stored campaigns filter state:', error);
      return null;
    }
  }
  return null;
};

export const storeCampaignsFilterState = (agencyId: string, state: CampaignsFilterState) => {
  localStorage.setItem(`${storedCampaignsFilterStateKey}-${agencyId}`, JSON.stringify(state));
};
